module.exports = __webpack_public_path__ + "assets/img/tgsm2.cd70bf30.png";